import * as Yup from "yup";

export const frequencyValidationSchema = Yup.object({
  name: Yup.string().required("Informe o nome.").max(255),
  days: Yup.number()
    .typeError("Informe um número inteiro de dias.")
    .required("Informe o intervalo em dias.")
    .integer("Informe um número inteiro de dias.")
    .min(1, "O intervalo deve ser de pelo menos 1 dia.")
    .max(2147483647, "O intervalo em dias é muito grande."),
});
